import React from "react";
import { Card, CardContent } from "./card";
import { cn } from "../../lib/utils";

const KPICard = ({
  title,
  value,
  icon: Icon,
  iconColor = "text-muted-foreground",
  valueColor = "text-primary",
  variant = "horizontal", // "horizontal" | "vertical"
  className,
  ...props
}) => {
  if (variant === "vertical") {
    return (
      <Card className={cn("", className)} {...props}>
        <CardContent className="flex items-center justify-center p-4">
          <div className="text-center">
            {Icon && <Icon className={cn("h-6 w-6 mx-auto mb-3", iconColor)} />}
            <p className="text-body-small text-muted-foreground font-medium mb-2">
              {title}
            </p>
            <p className={cn("text-3xl font-bold", valueColor)}>{value}</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  // Default horizontal variant
  return (
    <Card className={cn("", className)} {...props}>
      <CardContent className="p-4">
        <div className="flex items-center justify-between">
          <div className="flex-1 min-w-0">
            <p className="text-body-small text-muted-foreground font-medium mb-2">
              {title}
            </p>
            <p className={cn("text-3xl font-bold truncate", valueColor)}>
              {value}
            </p>
          </div>
          {Icon && (
            <Icon className={cn("h-6 w-6 ml-4 flex-shrink-0", iconColor)} />
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export { KPICard };
